<template>
  <v-app v-if="!loading" class="full-height">
    <div v-if="!hasError" class="full-height">
      <v-row
        justify="center"
        no-gutters
        class="third"
      >
        <v-col class="text-center white--text">
          <h1>{{ currentDate }}</h1>
        </v-col>
      </v-row>
      <div class="remaning-height">
        <v-card height="100%" width="100%" flat style="background-color:#cccc;">
          <v-carousel
            v-model="model"
            hide-delimiters
            cycle
            :show-arrows="false"
            height="100%"
            :interval="10000"
          >
            <v-carousel-item
              v-for="(sessionPage,i) in sessionsPerPage"
              :key="i"
            >
              <div class="d-flex justify-center align-center my-4 full-height">
                <CardDisplay
                  v-for="(session,index) in sessionPage"
                  :key="index"
                  :style="cardDisplayStyle"
                  :session="session"
                />
              </div>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </div>
    </div>
    <div v-else class="full-height">
      <ErrorBanner message="Site non trouvé" class="d-flex align-center justify-center full-height" :show-return-button="false" />
    </div>
  </v-app>
  <v-app v-else>
    <div class="full-height d-flex justify-center align-center">
      <Loader />
    </div>
  </v-app>
</template>
<script>
import { ref, computed, onBeforeMount } from '@vue/composition-api';
import { format, add, fromUnixTime, isWithinInterval } from 'date-fns';
import { fr } from 'date-fns/esm/locale';

import CardDisplay from '@/components/display/CardDisplay.vue';
import Loader from '@/components/common/Loader.vue';
import ErrorBanner from '@/components/common/ErrorBanner.vue';

import { sortArray, changeWorkspace } from '@/helpers/utils';
import { presenseStatus } from '@/helpers/variables';
import { getSiteByUrl } from '@/helpers/request';

import store from '@/store';

export default {
  components: { CardDisplay, Loader, ErrorBanner },
  setup (_, context) {
    const timer = ref(null);
    const model = ref(0);
    const date = ref(new Date());
    const loading = ref(false);
    const hasError = ref(true);

    const currentRoute = computed(() => context.root.$route);

    const currentDate = computed(() => format(date.value, 'dd MMMM yyyy', { locale: fr }));

    const plannerDisplayBefore = ref(45);

    const sessions = computed(() => {
      const dateToSearch = format(date.value, 'yyyy-MM-dd');
      const sessionByDate = store.getters.sessionByDate(dateToSearch);

      return sortArray(sessionByDate, 'start_time');
    });

    const cardDisplayStyle = computed(() => {
      const style = 'height: 90%;width: 33.33%;';

      // if (!isMobileView()) {
      //   style += 'width: 33.33%;';
      // }

      return style;
    });

    const handleFilters = session => {
      const computedFilters = [];

      Object.keys(currentRoute?.value?.query || {}).map(key => {
        switch (key) {
          case 'size': {
            const value = currentRoute.value.query[key];
            const valuesToCompare = value.split('|').map(v => v.toLowerCase());

            let values = [];

            if (valuesToCompare.some(v => ['poney', 'cheval'].includes(v.toLowerCase()))) {
              values = ['B', 'C', 'D', 'E'];
            }

            if (valuesToCompare.includes('shetland')) {
              values.push('A');
            }

            if (values.length) {
              computedFilters.push(values.some(item => (session.horse_size_category || []).find(i => i === item)));
            }

            break;
          }

          default:
        }
      });

      return computedFilters.length ? computedFilters.every(condition => condition) : true;
    };

    const sessionsPerPage = computed(() => {
      // const ItemsPerPage = isMobileView() ? 1 : 3;
      const ItemsPerPage = 3;
      let sessionsFiltered = sessions.value.filter(session => {
        const startTimeToCompare = add(new Date(fromUnixTime(session.start_time)), { minutes: -plannerDisplayBefore.value });
        const endTimeToCompare = add(new Date(fromUnixTime(session.start_time)), { minutes: 15 });

        // const diff = differenceInMinutes(new Date(fromUnixTime(session.start_time)), date.value);
        // const dateFilter = diff >= -30 && diff <= 15;

        const dateFilter = isWithinInterval(date.value, { start: startTimeToCompare, end: endTimeToCompare });

        const aditionalFilter = handleFilters(session);

        return ['SESSION_REPRISE', 'COMPETITION', 'EVENEMENT', 'STAGE'].includes(session.type) && dateFilter && aditionalFilter;
      });

      sessionsFiltered = sessionsFiltered.map(session => {
        session.participants = (session.participants || []).filter(p => p.presence_status !== presenseStatus.ABSENT);

        return session;
      });

      const rest = sessionsFiltered.length % ItemsPerPage;
      let pagesNumber = (sessionsFiltered.length / ItemsPerPage);
      if (rest) {
        pagesNumber += 1;
      }
      let start = 0;
      let end = ItemsPerPage;
      const pagesToReturn = [];
      let cycle = 1;
      do {
        pagesToReturn[cycle - 1] = sessionsFiltered.slice(start, end);
        end += ItemsPerPage;
        start += ItemsPerPage;
        cycle += 1;
      } while (cycle <= pagesNumber);
      return pagesToReturn;
    });

    onBeforeMount(async () => {
      loading.value = true;

      const response = await getSiteByUrl(currentRoute.value.params.workspace);
      if (response && response.data) {
        plannerDisplayBefore.value = response.data?.plannerDisplayBefore || 45;
        await changeWorkspace({ name: response.data.name, code: response.data.workspace }, true, false);
        store.commit('setSiteInfo', response.data);
        hasError.value = false;
      }

      if (!store.state.isLazyLoaded.places) {
        await store.dispatch('getPlaces');
      }
      if (!store.state.isLazyLoaded.instructors) {
        await store.dispatch('getInstructors');
      }
      if (!store.state.isLazyLoaded.horses) {
        await store.dispatch('getHorses');
      }

      // call function every minute
      timer.value = setInterval(() => {
        date.value = new Date();
      }, 60000); // 1 min

      loading.value = false;
    });
    return { cardDisplayStyle, currentDate, model, sessionsPerPage, loading, hasError };
  }
};
</script>

<style scoped>
  .remaning-height {
    height: calc(100% - 48px);
  }
</style>
